var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCoupon = function SvgCoupon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#303030",
    d: "M8.75 9.167a.917.917 0 0 0-.917.916v1.834a.917.917 0 1 0 1.834 0v-1.834a.917.917 0 0 0-.917-.916m11 .916a.917.917 0 0 0 .917-.916V5.5a.916.916 0 0 0-.917-.917H3.25a.917.917 0 0 0-.917.917v3.667a.917.917 0 0 0 .917.916.917.917 0 1 1 0 1.834.917.917 0 0 0-.917.916V16.5a.917.917 0 0 0 .917.917h16.5a.917.917 0 0 0 .917-.917v-3.667a.916.916 0 0 0-.917-.916.917.917 0 1 1 0-1.834m-.916-1.668a2.75 2.75 0 0 0 0 5.17v1.998H9.667a.917.917 0 1 0-1.833 0H4.167v-1.998a2.75 2.75 0 0 0 0-5.17V6.417h3.667a.917.917 0 1 0 1.833 0h9.167z"
  })));
};
export default SvgCoupon;